<template>
	<div>
		<Toptab />
		<div class="pro-box container">
			<div class="row pro-row">

				<div class="col-md-6 pro-img">
					<img src="../assets/img/pro-ERP.jpg">
				</div>
				<div class="col-md-6">
					<h5>
						跨境电商ERP

					</h5>
					<p>集成了传统的进销存软件和主流的电商平台功能，以平台和进销存为核心，集成商品管理、平台管理、采购、物流、仓储、客服、营销、订单、财务结算、多维度的数据报表，数据分析等功能一体的ERP
						业务管理系统，通过软件自动同步技术，实现订单数据的自动化，简易化，批量化管理，高效率的订单管理。实现一套软件管理多个仓库和所有订单自动化。</p>

				</div>
			</div>


			<div class="row pro-row">
				<div class="col-md-6">
					<h5>手机维修ERP</h5>
					<p>通过对系统各个菜单的展示以及解析，让入驻商户对系统功能以及操作方面有更深的了解及快速掌握。本系统在管理维修单和库存信息之前，需先在“基本设置”菜单项中把故障信息、产品信息都完善，才便于后面添加维修单、入库产品信息的获取，如果在操作添加维修单和入库产品无产品信息，就返到“基本设置”菜单处完善故障信息、产品信息即可。系统设置是系统首页，展示了控制台所有菜单，操作每个菜单功能就实现管理的需求及快速查询有关常用信息数据，可重新设置本店商户资料信息、会员充值入口、以及退出本系统。
					</p>
					<p>一、系统设置：商户资料、店铺管理、角色管理、员工管理、短信群发
					</p>
					<p>二、基本设置：供应商管理、故障明细、产品明细
					</p>
					<p>三、库存作业：入库管理、出库管理、入库统计、出库统计、本店库存、库存共享、挂账提货单、挂账销售单、销售列表、销售人业绩统计
					</p>
					<p> 四、维修管理：散户维修单、大客户维修单、维修单统计、挂账订单、保修订单、结算订单、退款订单、维修人员业绩统计、接待人员业绩统计
					</p>
					<p>五、统计查询：维修业绩统计、供应商款统计、客户款统计、销售业绩统计
					</p>

				</div>
				<div class="col-md-6 pro-img">
					<img src="../assets/img/pro-ERP2.jpg">
				</div>


			</div>

			<div class="row pro-row">

				<div class="col-md-6 pro-img">
					<img src="../assets/img/pro-erp3.jpg">
				</div>
				<div class="col-md-6">
					<h5>WEBERP</h5>
					<p>
						功能强大 提供全面的财务特性包括总帐、应收/ 应付帐目等；订单管理支持发票的跟踪与管理；销售费用管理及强大的销售分析功能；简单易用
						易于操作的Web界面，权限角色管理便于员工、客户和供应商使用，支持多公司、多币种、多税种、多库存管理，非常适合中小型企业使用。
					<p>
						应付帐模块：会计里的应付帐是企业应付购货款等帐，它包括了发票管理、供应商管理、支票管理帐龄分析等。它能够和采购模块、库存模块完全集成以替代过去繁琐的手工操作
					</p>
					<p>财务管理模块：可将由生产活动、采购活动输入的信息自动计入财务模块生成总账、会计报表，取消了输入凭证繁琐的过程，几乎完全替代以往传统的手工操作。
					</p>
					<p>总帐模块：它的功能是处理记账凭证输入、登记，输出日记账、一般明细账及总分类账，编制主要会计报表。
					</p>
					<p>应收帐模块：是指企业应收的由于商品赊欠而产生的正常客户欠款帐。它包括发票管理、客户管理、付款管理、帐龄分析等功能。</p>
					</p>


				</div>

			</div>
			<div class="row pro-row">
				<div class="col-md-6">
					<h5>制造业通用erp5</h5>
					<p>功能说明</p>
					<p>采购业务:</p>
					<p>[采购订单]
						[采购入库]
						[采购退货出库]</p>
					<p>销售业务:</p>
					<p>[销售合同]
						[销售订单]
						[销售出库]
						[销售退货入库]</p>
					<p>库存管理:</p>
					<p>[库间调拨]
						[库存盘点]</p>
					<p>加工业务:</p>
					<p>[存货拆分]
						[成品委托生产订单]
						[成品委托生产入库]</p>



				</div>
				<div class="col-md-6 pro-img">
					<img src="../assets/img/pro-d2.png">
				</div>
			</div>
			<div class="pro-row row">
				<div>
					<div class="col-md-6 pro-img">
						<img src="../assets/img/pro-d3.jpg">
					</div>
					<div class="col-md-6 pro-img">
						<img src="../assets/img/pro-d4.jpg">
					</div>
				</div>
			</div>
			<div class="pro-row">
				<div>
					<h5>
						通用crm
					</h5>
					<p>集成了传统的进销存软件和主流的电商平台功能，以平台和进销存为核心，集成商品管理、平台管理、采购、物流、仓储、客服、营销、订单、财务结算、多维度的数据报表，数据分析等功能一体的ERP
						业务管理系统，通过软件自动同步技术，实现订单数据的自动化，简易化，批量化管理，高效率的订单管理。实现一套软件管理多个仓库和所有订单自动化。</p>

				</div>
			</div>

			<div class="pro-row">
				<div>
					<h5>
						云办公
					</h5>
					<p>集成了传统的进销存软件和主流的电商平台功能，以平台和进销存为核心，集成商品管理、平台管理、采购、物流、仓储、客服、营销、订单、财务结算、多维度的数据报表，数据分析等功能一体的ERP
						业务管理系统，通过软件自动同步技术，实现订单数据的自动化，简易化，批量化管理，高效率的订单管理。实现一套软件管理多个仓库和所有订单自动化。</p>

				</div>
			</div>

			<div class="pro-row">
				<div>
					<h5>
						中小型企业ERP与财务管理软件

					</h5>
					<p>
						功能强大 提供全面的财务特性包括总帐、应收/ 应付帐目等；订单管理支持发票的跟踪与管理；销售费用管理及强大的销售分析功能；简单易用
						易于操作的Web界面，权限角色管理便于员工、客户和供应商使用，支持多公司、多币种、多税种、多库存管理，非常适合中小型企业使用。
					<p>
						应付帐模块：会计里的应付帐是企业应付购货款等帐，它包括了发票管理、供应商管理、支票管理帐龄分析等。它能够和采购模块、库存模块完全集成以替代过去繁琐的手工操作
					</p>
					<p>财务管理模块：可将由生产活动、采购活动输入的信息自动计入财务模块生成总账、会计报表，取消了输入凭证繁琐的过程，几乎完全替代以往传统的手工操作。
					</p>
					<p>总帐模块：它的功能是处理记账凭证输入、登记，输出日记账、一般明细账及总分类账，编制主要会计报表。
					</p>
					<p>应收帐模块：是指企业应收的由于商品赊欠而产生的正常客户欠款帐。它包括发票管理、客户管理、付款管理、帐龄分析等功能。</p>
					</p>
				</div>
			</div>

			<div class="pro-row">
				<div>
					<h5>
						保险行业crm（移动端）

					</h5>
					<p>
						功能 客户信息、消息通知、客户线索、客户跟进、目标名单、目标制定、销售记录、日程安排、客户保单、我的保单、我的话术、会员管理

					</p>

				</div>
			</div>

			<div class="pro-row">
				<div>
					<h5>
						门诊ERP

					</h5>
					<p>
						说明 :

						一、新开就诊: 就诊列表 医生排班 门诊挂号 挂号列表 患者库
						二、收费发药
						三、药品进销存: 药品信息维护 供应商维护 采购入库 入库审核 库存查询
						四、数据统计: 诊所收支统计 药品销售统计 检查项目统计 年月报表统计 工作量统计

					</p>

				</div>
			</div>
			<div class="erweima">
				<p>联系方式：扫描微信二维码咨询</p>
				<img src="../assets/img/wechaterweima.jpg">
			</div>
		</div>
		<Footbar />
	</div>
</template>

<script>
	import Toptab from '../components/toptab.vue'
	import Footbar from "../components/footbar.vue"
	import "../assets/js/jquery-1.11.0.min.js"
	export default {
		components: {
			Toptab,
			Footbar
		}

	}
</script>

<style scoped>
	@import url("../assets/css/commen.css");
	@import url("../assets/css/products.css");
</style>
